import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import LanguageSelector from './components/LanguageSelector';
import { useLanguage } from './contexts/LanguageContext';

function Home() {
  const navigate = useNavigate();
  const { translations, language } = useLanguage();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);
  
  return (
    <div className={`bg-beige-medium p-4 min-h-dvh flex justify-center items-center flex-col relative`}>
      
      <div className="absolute top-4 right-4 sm:top-6 sm:right-6 xl:top-10 xl:right-10 z-50">
        <LanguageSelector />
      </div>
      <img className="absolute top-0 left-0 w-full h-full object-cover opacity-[0.03]" src="/images/bg-pattern-1.webp" alt="pattern" width="100%" height="100%" />
      <img className="absolute top-0 left-0 w-full h-full object-cover opacity-[0.03]" src="/images/bg-pattern-2.webp" alt="pattern" width="100%" height="100%" />
      <div className={`bg-beige-medium/70 backdrop-blur-[1px] relative rounded-[70%] text-center py-0 sm:py-10 px-0 sm:px-10 xl:px-[80px] w-full max-w-[1020px] z-10 transition-all duration-300 ${isLoaded ? 'scale-100' : 'scale-0'}`}>
      <img
          className={`w-[280px] xl:w-[360px] mx-auto transition-all duration-300`}
          src={language === 'hi' ? '/images/awg0.webp' : '/images/awg.webp'}
          alt="logo"
          width="360"
          height="200"
        />
        <h1 className="text-brown-primary font-[ArtifexHandCF] text-[40px] sm:text-[56px] xl:text-[72px] leading-[120%] font-semibold mt-8 sm:mt-12 xl:mt-14">{translations.home.title}</h1>
        <p className="text-[18px] sm:text-[22px] xl:text-[28px] leading-[132%] text-dark-shade1 mt-4 sm:mt-5 xl:mt-6">{translations.home.description}</p>
        <button className="bg-brown-primary font-[Forum] text-white text-[18px] sm:text-[22px] xl:text-[28px] leading-[120%] mt-10 sm:mt-14 xl:mt-16 py-3 rounded-full border-none cursor-pointer h-[56px] sm:h-[72px] w-full sm:w-auto sm:min-w-[300px] transition-all duration-300 ease-in-out hover:bg-[#662E1A]" onClick={() => navigate('/feedback')}>{translations.home.giveFeedback}</button>
      </div>
      <img className="absolute bottom-4 right-4 sm:bottom-6 sm:right-6 xl:bottom-10 xl:right-10 w-[72px] sm:w-[90px] xl:w-[120px] z-10" src="/images/logo.svg" alt="logo" width="120" height="98" />
    </div>
  );
}

export default Home;

